import {FC} from "react";
import {CustomModalAuth} from "../ui/CustomModal";

interface IProps {
  isOpenAuthModal: boolean;
  onCloseModal: () => void;
  onLogout: () => void;
}

export const LogOutPage: FC<IProps> = ({
  isOpenAuthModal,
  onCloseModal,
  onLogout,
}) => {
  return (
    <CustomModalAuth
      title="Выйти ?"
      isOpenAutModal={isOpenAuthModal}
      onCloseModal={onCloseModal}
    >
      <div
        style={{
          background: "#23272b",
          color: "#fafafa",
          padding: "32px 40px",
          borderRadius: "12px",
          minWidth: 320,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "24px",
        }}
      >
        <div style={{display: "flex", gap: 16}}>
          <button
            onClick={onLogout}
            style={{
              background: "#3a3f44",
              color: "#fafafa",
              border: "none",
              borderRadius: 6,
              padding: "12px 24px",
              fontSize: 16,
              cursor: "pointer",
              fontWeight: 500,
              letterSpacing: 1,
            }}
          >
            Выйти
          </button>
          <button
            onClick={onCloseModal}
            style={{
              background: "#181b1f",
              color: "#fafafa",
              border: "1px solid #333",
              borderRadius: 6,
              padding: "12px 24px",
              fontSize: 16,
              cursor: "pointer",
              fontWeight: 500,
              letterSpacing: 1,
            }}
          >
            Отмена
          </button>
        </div>
      </div>
    </CustomModalAuth>
  );
};
